import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const baseUrl = process.env.REACT_APP_BASE_URL;

const initialState = {
    mode: "light",
    userId: "63701cc1f03239b7f700000e",
    userState: "",
    defaultProperty: "",
    propertyName: localStorage.getItem("propertyName") || "",
};

export const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setMode: (state) => {
            state.mode = state.mode === "light" ? "dark" : "light";
        },
        setUserState(state, action) {
            state.userState = action.payload;
        },
        setDefaultPropertyState(state, action) {
            state.defaultProperty = action.payload;
        },
        setPropertyName(state, action) {
            state.propertyName = action.payload;
            localStorage.setItem("propertyName", action.payload);
        },
    },
});

export const handelLogout = () => async (dispatch) => {
    localStorage.clear();
    dispatch(setUserState(new Date().toLocaleString()));
    window.location.href = "/login";
};

export const handelResponse = (res) => async (dispatch) => {
    let returnValue = null;
    const status = res?.status;
    switch (status) {
        case 200:
            returnValue = res;
            break;
        case 201:
            returnValue = res;
            break;
        case 400:
            // dispatch(throwError(res));
            returnValue = res;
            // returnValue = null;
            break;
        case 401:
            dispatch(handelLogout());
            break;
        case 403:
            dispatch(handelLogout());
            break;
        default:
            // throwError({ message: "Something went wrong!" });
            returnValue = null;
            break;
    }

    return returnValue;
};

export const login = async (dispatch, email, password) => {
    try {
        const res = await axios.post(`${baseUrl}users/login`, { email, password });
        const response = await dispatch(handelResponse(res));
        if (response?.status === 200) {
            dispatch(setUserState(JSON.stringify({ token: response.data.data.auth.accessToken })));
            if (response.data.data.property) {
                dispatch(
                    setDefaultPropertyState({
                        propertyId: response.data.data.property.id,
                        propertyName: response.data.data.property.propertyName,
                    })
                );
            }
            return response.data;
        }
    } catch (error) {
        throw new Error(error.response?.data?.message || "An unexpected error occurred.");
    }
};

export const setPropertyAsDefault = async (dispatch, propertyId) => {
    try {
        const response = await axios.post(`${baseUrl}users/set-as-default`, { propertyId });
        if (response?.status === 200) {
            localStorage.setItem("propertyId", response.data.data.property.id);
            localStorage.setItem("propertyName", response.data.data.property.propertyName);
        }
        return response.data;
    } catch (error) {
        console.log("error: ", error);
    }
};

export const getDefaultProperty = async (dispatch) => {
    try {
        const response = await axios.get(`${baseUrl}users/get-default`);
        if (response?.status === 200) {
            if (response.data.data.property) {
                dispatch(setDefaultPropertyState(response.data.data.property.id));
                dispatch(setPropertyName(response.data.data.property.propertyName));
            } else {
                dispatch(setDefaultPropertyState(""));
                dispatch(setPropertyName(""));
            }
            // dispatch(setDefaultPropertyState(response.data.data.property.id));
            // dispatch(setPropertyName(response.data.data.property.propertyName));
        }
        return response.data;
    } catch (error) {
        console.log("error: ", error);
        throw error;
    }
};

export const { setMode, setUserState, setDefaultPropertyState, setPropertyName } =
    globalSlice.actions;

export default globalSlice.reducer;
